import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import useUserInfo from '../../../../hooks/useUserInfo';

const SELECTED = 'px-3 py-2 text-xs font-semibold text-white bg-blue-dark';
const NOT_SELECTED = 'px-3 py-2 text-xs hover:text-white hover:bg-blue-dark text-grey';

const Navigation = () => {
    const { t } = useTranslation();
    const user = useUserInfo();
    if (user === null) return null; // TODO check with Marvin if this is correct

    return (
        <div className="flex flex-wrap gap-2 mb-2">
            <Link
                from="/leads/details/$leadId/history"
                to="$categoryId"
                params={{ categoryId: 'all' }}
                activeProps={{ className: SELECTED }}
                inactiveProps={{ className: NOT_SELECTED }}
            >
                {t('HISTORY.NAVIGATION.all')}
            </Link>
            <Link
                from="/leads/details/$leadId/history"
                to="$categoryId"
                params={{ categoryId: 'notes' }}
                activeProps={{ className: SELECTED }}
                inactiveProps={{ className: NOT_SELECTED }}
            >
                {t('HISTORY.NAVIGATION.notes')}
            </Link>
            <Link
                from="/leads/details/$leadId/history"
                to="$categoryId"
                params={{ categoryId: 'communication' }}
                activeProps={{ className: SELECTED }}
                inactiveProps={{ className: NOT_SELECTED }}
            >
                {t('HISTORY.NAVIGATION.communication')}
            </Link>
            <Link
                from="/leads/details/$leadId/history"
                to="$categoryId"
                params={{ categoryId: 'documents' }}
                activeProps={{ className: SELECTED }}
                inactiveProps={{ className: NOT_SELECTED }}
            >
                {t('HISTORY.NAVIGATION.documents')}
            </Link>
            <Link
                from="/leads/details/$leadId/history"
                to="$categoryId"
                params={{ categoryId: 'events' }}
                activeProps={{ className: SELECTED }}
                inactiveProps={{ className: NOT_SELECTED }}
            >
                {t('HISTORY.NAVIGATION.events')}
            </Link>
        </div>
    );
};

export default Navigation;
